import styled from "styled-components";

export const TopBarreStyled = styled.section`
  animation-delay: 0.5s;
  opacity: 1;
`;
